import {post} from "./utils";

export async function refreshChildUrls(rootPageTypeID: number, extractUrlsFromPage: string, proxy: string): Promise<void> {
    await post<{}, any>("/api/urls/child-refresh", {
        page_type_id: rootPageTypeID,
        source_url: extractUrlsFromPage,
        proxy: proxy
    })
}
